<template>
   <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <switch-input v-model="form.knowledge_base_status" label="وضعیت پایگاه دانش"></switch-input>
            <p class="text-grey-darken-1 text-small font-weight-medium">تا زمانی که وضعیت نمایش پایگاه دانش غیرفعال باشد به جز مدیرارشد هیچ کاربری امکان مشاهده آن را نخواهد داشت.</p>
            <div class="d-flex align-center my-5">
                <p class="text-grey-darken-2 text-meta me-2">محتوای تکمیلی صفحه اول:</p>
                <v-select
                    :items="[{value: null, title: 'هیچ کدام'}, {value: 'most_viewed', title: 'پربازدیدترین مطالب'}, {value: 'most_liked', title: 'محبوب ترین مطالب'}, {value: 'most_recent', title: 'آخرین مطالب'}]"
                    style="max-width:200px"
                    hide-details
                    v-model="form.knowledge_base_default_articles_sort"
                ></v-select>
            </div>
            <div class="d-flex align-center my-5">
                <p class="text-grey-darken-2 text-meta me-2">انتخاب رنگ:</p>
                <v-menu :close-on-content-click="false" content-class="sidebar-items" location="left" z-index="10" v-model="colorMenu">
                    <template #activator="{ props }">
                        <v-text-field
                            dir="ltr"
                            type="button"
                            :model-value="form.knowledge_base_color.substr(0,7)"
                            v-bind="props"
                            @click="colorMenu = true"
                            style="max-width:200px"
                            class="arial-input"
                            hide-details
                        >
                            <template #append-inner>
                                <v-icon :color="form.knowledge_base_color">circle</v-icon>
                            </template>
                        </v-text-field>
                    </template>
                    <v-color-picker
                        class="arial-input"
                        dot-size="15"
                        swatches-max-height="200"
                        v-model="form.knowledge_base_color"
                        mode="hexa"
                    ></v-color-picker>
                </v-menu>
            </div>
            <p class="text-grey-darken-2 text-meta mb-2">توضیحات پایگاه دانش:</p>
            <ckeditor
                v-model="form.knowledge_base_message"
                class="mb-7"
            />
            <file-input
                :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span class='font-weight-medium'>فایل لوگوی پایگاه دانش</span><span class='d-block'>فرمت: png | ابعاد: 50 * 150 | سایز فایل: 500KB</span></div>`"
                :style="{backgroundColor: '#e7e7e7', borderRadius: '4px', height: '70px'}"
                :types="['png']"
                :mimeTypes="['image/png']"
                :size="512000"
                style="width: 300px; height: 50px;"
                type="image"
                imageSize="auto"
                ref="kbLogoInput"
                @updated="kbLogoChanged"
            ></file-input>
            <div class="mt-4">
                <v-btn @click="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
            </div>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "تنظیمات پایگاه دانش",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.kb_core;
    },
    data() {
        return {
            loading: false,
            colorMenu:false,
            form:{
                knowledge_base_color:this.$system.settings.knowledge_base_color,
                knowledge_base_status: this.$system.settings.knowledge_base_status,
                knowledge_base_message: this.$system.settings.knowledge_base_message,
                knowledge_base_default_articles_sort: this.$system.settings.knowledge_base_default_articles_sort,
            },
        };
    },
    methods: {
        kbLogoChanged() {
            let file = this.$refs.kbLogoInput.getValidFiles();
            this.form.knowledge_base_logo_name = file == null ? 'unset' : file['file'];
        },
        submit(){
            this.loading = true;
            this.$updateSettings(this.$object.toFormData({...this.form, _method: 'put'})).then(async (res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setSystemSettings(true);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(()=>{
            this.$loading.start();
            if(this.$system.settings.knowledge_base_logo_name)
                this.$refs.kbLogoInput.setImageFileFromServer(this.$system.settings.knowledge_base_logo_name);
            this.$loading.finish();
        })
    },
};
</script>
